// extracted by mini-css-extract-plugin
export default {"container":"VoiceLanguageListCell_container__Z0ea-","languageText":"VoiceLanguageListCell_languageText__OhVQC"};